module.exports = __webpack_public_path__ + "resources/7e2c3c7df9c7b143439bfef7e662c353.png";


//////////////////
// WEBPACK FOOTER
// ./resources/card-templates/oversizedlocation.png
// module id = 219
// module chunks = 0